<template>
  <div>
    <h1>{{ pageTitle }}</h1>
    <div v-if="user.email === 'jeremy@ecosupplycenter.com' || user.email === 'admin@ecosupplycenter.com' || user.email === 'anthony@ecosupplycenter.com'">
    <!-- Line below is for debugging -->
    <!-- <div v-if="user.email === 'admin@ecosupplycenter.com' || user.email === 'anthony@ecosupplycenter.com'"> -->
      <h3>Downloads</h3>
      <a href="/cad/tekstur-training-patterns.zip" class="button" download>Download All Training Patterns</a>
    </div>
    <div v-else>
      You do not have access to the information on this page.
    </div>
  </div>
</template>

<script>
import netlifyIdentity from 'netlify-identity-widget'
import { mapGetters, mapActions } from 'vuex'

netlifyIdentity.init({
  APIUrl: 'https://brand.tekstur.com/.netlify/identity',
  logo: true // you can try false and see what happens
})
// import Color from '@/components/Color.vue'
export default {
  components: {
    // Color
  },
  computed: {
    ...mapGetters('user', {
      isLoggedIn: 'getUserStatus',
      user: 'getUser'
    }),
    username () {
      return this.user ? this.user.username : ', there!'
    }
  },
  data () {
    return {
      pageTitle: 'CNC & CAD Pattern Files'
    }
  },
  mounted () {
    netlifyIdentity.on('signup', () => this.$router.push({ name: 'home' }))
    netlifyIdentity.on('close', () => this.$router.push({ name: 'home' }))
  },
  methods: {
    ...mapActions('user', {
      updateUser: 'updateUser'
    }),
    triggerNetlifyIdentityAction (action) {
      if (action === 'login' || action === 'signup') {
        netlifyIdentity.open(action)
        netlifyIdentity.on(action, user => {
          netlifyIdentity.close()
          let currentUser = {
            username: user.user_metadata.full_name,
            email: user.email,
            access_token: user.token.access_token,
            expires_at: user.token.expires_at,
            refresh_token: user.token.refresh_token,
            token_type: user.token.token_type
          }
          this.updateUser({
            currentUser: currentUser
          })
          this.$router.push({ name: 'home' })
        })
      } else if (action === 'logout') {
        this.updateUser({
          currentUser: null
        })
        netlifyIdentity.logout()
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>
